import {inject, provideAppInitializer} from '@angular/core';

import {AppConfigService} from './app-config.service';

const initializerConfigFunction = (appConfig: AppConfigService): Function => {
	return () => appConfig.loadAppConfig();
};

export const configProvider = provideAppInitializer(() => {
	const appConfig = inject(AppConfigService);
	return appConfig.loadAppConfig();
});
